dashamail = window.dashamail || function () { dashamail.queue.push(arguments); };
dashamail.queue = dashamail.queue || [];
dashamail('create');
var dashamailScript = document.createElement('script');
dashamailScript.setAttribute('async', 'async');
dashamailScript.setAttribute('src', 'https://directcrm.dashamail.com/scripts/v2/tracker.js');
document.head.appendChild(dashamailScript);

// web-push подписка. "Даша" использует OneSignal, который может быть гораздо гибче. Если использовать, то лучше его самого
// window.DashaSDK = window.DashaSDK || [];
// window.DashaSDK.appId = "72e1e6fa-8179-4e83-b945-a6271a921b82";
// var dashamailSDKScript = document.createElement('script');
// dashamailSDKScript.setAttribute('async', 'async');
// dashamailSDKScript.setAttribute('src', 'https://directcrm.dashamail.com/dasha-push-sdk.js');
// document.head.appendChild(dashamailSDKScript);
// DashaPush.showSlidedownPrompt();